import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
};

export type AcquisitionInput = {
  referrer?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Array<Maybe<Scalars['Float']>>>;
  country?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
};

export type AdminOrder = {
  __typename?: 'AdminOrder';
  _id: Scalars['ID'];
  address?: Maybe<Address>;
  amountPaid?: Maybe<Scalars['Int']>;
  cardsCount?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  collectTimeslot?: Maybe<Timeslot>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customFields?: Maybe<Array<CustomField>>;
  datePaid?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  email: Scalars['String'];
  isDelivered?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  paymentStatus?: Maybe<Scalars['String']>;
  publicLink?: Maybe<Scalars['String']>;
  quantities: Array<Quantity>;
  sellerGroup?: Maybe<AdminSellerGroup>;
};

export type AdminSellerGroup = {
  __typename?: 'AdminSellerGroup';
  _id: Scalars['ID'];
  code: Scalars['String'];
  facebookShares: Scalars['Int'];
  names: Scalars['String'];
  offset: Scalars['Int'];
  orderValue: Scalars['Int'];
  orders: Array<AdminOrder>;
  points: Scalars['Int'];
  position: Scalars['Int'];
  secret: Scalars['String'];
  sellers: Array<Seller>;
  tags: Array<Maybe<Scalars['String']>>;
};

export type Article = IArticle & {
  __typename?: 'Article';
  _id: Scalars['ID'];
  defaultQuantity?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  extraInfo?: Maybe<Array<ExtraInfo>>;
  features?: Maybe<Array<ArticleFeature>>;
  groupId?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  itemsLeft?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  price: Scalars['Int'];
  purchasePrice?: Maybe<Scalars['Int']>;
};

export type ArticleFeature = {
  __typename?: 'ArticleFeature';
  key: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type ArticlePackage = {
  __typename?: 'ArticlePackage';
  _id: Scalars['ID'];
  articleTemplates: Array<ArticleTemplate>;
  defaultCampaignSettings?: Maybe<DefaultCampaignSettings>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  locales?: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Scalars['String'];
  partner: Partner;
  partnerId?: Maybe<Scalars['ID']>;
  possibleArticleTemplates?: Maybe<Array<Maybe<ArticleTemplate>>>;
  profitMargins?: Maybe<ProfitMargins>;
  slug: Scalars['String'];
  tagIds?: Maybe<Array<Scalars['ID']>>;
};


export type ArticlePackageArticleTemplatesArgs = {
  first?: InputMaybe<Scalars['Int']>;
  lang?: InputMaybe<Scalars['String']>;
};

export type ArticlePackageTag = {
  __typename?: 'ArticlePackageTag';
  _id: Scalars['ID'];
  type: Scalars['String'];
  value: Scalars['String'];
};

export type ArticleTemplate = {
  __typename?: 'ArticleTemplate';
  _id: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  extraInfo?: Maybe<Array<ExtraInfo>>;
  features?: Maybe<Array<ArticleFeature>>;
  groupId?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  lang: Scalars['String'];
  name: Scalars['String'];
  purchasePrice: Scalars['Int'];
  requiredOrderMultiple?: Maybe<Scalars['Int']>;
  sellingPrice: Scalars['Int'];
};

export type BillingDetails = {
  __typename?: 'BillingDetails';
  address: Address;
  billingEmail: Scalars['String'];
  legalEntityName: Scalars['String'];
  vatNumber?: Maybe<Scalars['String']>;
  vatTariff?: Maybe<Scalars['Float']>;
};

export type BillingDetailsInput = {
  address?: InputMaybe<InputAddress>;
  billingEmail?: InputMaybe<Scalars['String']>;
  legalEntityName?: InputMaybe<Scalars['String']>;
  vatNumber?: InputMaybe<Scalars['String']>;
  vatTariff?: InputMaybe<Scalars['Float']>;
};

export type BooleanOperators = {
  in?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type BooleanPossibleFilter = {
  __typename?: 'BooleanPossibleFilter';
  label: Scalars['String'];
  value?: Maybe<Scalars['Boolean']>;
};

export type Campaign = {
  __typename?: 'Campaign';
  _id: Scalars['ID'];
  acceptDonations?: Maybe<Scalars['Boolean']>;
  analytics?: Maybe<CampaignAnalytics>;
  articlePackageIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  articlePackages?: Maybe<Array<ArticlePackage>>;
  articles?: Maybe<Array<IArticle>>;
  articlesAmount?: Maybe<Scalars['Int']>;
  avgRating?: Maybe<Scalars['Float']>;
  category?: Maybe<Scalars['Int']>;
  charity?: Maybe<Charity>;
  codeGenerationMethod?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deliveryDate?: Maybe<SuggestedDeliveryDate>;
  deliveryOptions: DeliveryOptions;
  enabledArticleTemplateIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  firstOrder?: Maybe<Scalars['String']>;
  formFields?: Maybe<Array<FormField>>;
  hasOrderWithAddress: Scalars['Boolean'];
  headerImgUrl?: Maybe<Scalars['String']>;
  interfaceConfig?: Maybe<InterfaceConfig>;
  isSellerGroupHidden?: Maybe<Scalars['Boolean']>;
  isSellerGroupReadOnly?: Maybe<Scalars['Boolean']>;
  isSellerGroupRequired?: Maybe<Scalars['Boolean']>;
  isSellingEnabled: Scalars['Boolean'];
  isUpdateAllowed?: Maybe<Scalars['Boolean']>;
  lastDatePaid?: Maybe<Scalars['DateTime']>;
  minCloseAtDate?: Maybe<Scalars['String']>;
  minimumOrderValue?: Maybe<Scalars['Int']>;
  minimumTotalArticleCount?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  onboarding?: Maybe<OnboardingSettings>;
  onlyFinalOrderAllowed: Scalars['Boolean'];
  openGraphTags?: Maybe<OpenGraphTags>;
  organisation?: Maybe<Organisation>;
  organisationType?: Maybe<Scalars['String']>;
  partner?: Maybe<Partner>;
  partnerReview?: Maybe<PartnerReview>;
  paymentProvider?: Maybe<Scalars['String']>;
  possibleArticleTemplates?: Maybe<Array<Maybe<ArticleTemplate>>>;
  publicLink?: Maybe<Scalars['String']>;
  sellerGroups?: Maybe<Array<PublicSellerGroup>>;
  showFullLastnames?: Maybe<Scalars['Boolean']>;
  showScoreboard: Scalars['Boolean'];
  slug: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  tenant?: Maybe<Tenant>;
  textConfig?: Maybe<TextConfig>;
  timeslots?: Maybe<Timeslots>;
  totalPurchasePrice?: Maybe<Scalars['Int']>;
  totalTurnover?: Maybe<Scalars['Int']>;
  winnerCount?: Maybe<Scalars['Int']>;
};


export type CampaignAnalyticsArgs = {
  lastXDays?: InputMaybe<Scalars['Int']>;
};


export type CampaignDeliveryDateArgs = {
  closeAt?: InputMaybe<Scalars['String']>;
};

export type CampaignAnalytics = {
  __typename?: 'CampaignAnalytics';
  allTimeAvgOrderValue: Scalars['Int'];
  allTimeCharityRevenue?: Maybe<Scalars['Int']>;
  allTimeItemsSold?: Maybe<Scalars['Int']>;
  allTimeOrderCount: Scalars['Int'];
  allTimeOrganisationCommission?: Maybe<Scalars['Int']>;
  allTimeOrganisationRevenue?: Maybe<Scalars['Int']>;
  allTimePartnerCommission?: Maybe<Scalars['Int']>;
  allTimePartnerRevenue?: Maybe<Scalars['Int']>;
  allTimeTurnover?: Maybe<Scalars['Int']>;
  perArticle?: Maybe<Array<Maybe<PerArticle>>>;
  perDay?: Maybe<Array<Maybe<PerDay>>>;
};

export type CampaignConnection = {
  __typename?: 'CampaignConnection';
  edges: Array<CampaignEdge>;
  pageInfo: CampaignPageInfo;
  possibleFilters?: Maybe<CampaignPossibleFilters>;
  totalCount: Scalars['Int'];
};

export type CampaignEdge = {
  __typename?: 'CampaignEdge';
  cursor: Scalars['String'];
  node: Campaign;
};

export type CampaignFilterParameter = {
  avgRating?: InputMaybe<IntegerOperators>;
  closeAt?: InputMaybe<DateOperators>;
  isSellingEnabled?: InputMaybe<BooleanOperators>;
  status?: InputMaybe<StringOperators>;
  textSearch?: InputMaybe<Scalars['String']>;
};

export type CampaignPageInfo = IPageInfo & {
  __typename?: 'CampaignPageInfo';
  categoryCounters?: Maybe<Array<Maybe<CategoryCounters>>>;
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type CampaignPossibleFilters = {
  __typename?: 'CampaignPossibleFilters';
  isSellingEnabled?: Maybe<Array<BooleanPossibleFilter>>;
  status?: Maybe<Array<StringPossibleFilter>>;
};

export type CampaignSortParameter = {
  articlePackageName?: InputMaybe<SortOrder>;
  articlesAmount?: InputMaybe<SortOrder>;
  avgRating?: InputMaybe<SortOrder>;
  category?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  closeAt?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deliveryDate?: InputMaybe<SortOrder>;
  isSellingEnabled?: InputMaybe<SortOrder>;
  lastDatePaid?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organisationName?: InputMaybe<SortOrder>;
  organisationType?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  totalPurchasePrice?: InputMaybe<SortOrder>;
};

export type CampaignsAsXlsxResponse = {
  __typename?: 'CampaignsAsXLSXResponse';
  status: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type CategoryCounters = {
  __typename?: 'CategoryCounters';
  amount?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['Int']>;
};

export type Charity = {
  __typename?: 'Charity';
  _id: Scalars['ID'];
  name: Scalars['String'];
  showProfitToOrganisation?: Maybe<Scalars['Boolean']>;
};

export type ClosingPeriod = {
  __typename?: 'ClosingPeriod';
  _id: Scalars['ID'];
  end: Scalars['String'];
  reason: Scalars['String'];
  start: Scalars['String'];
};

export type ClosingPeriodInput = {
  _id?: InputMaybe<Scalars['ID']>;
  end: Scalars['String'];
  reason: Scalars['String'];
  start: Scalars['String'];
};

export type ConfirmedDeliveryRangeInput = {
  end: Scalars['String'];
  start: Scalars['String'];
};

export type CustomField = {
  __typename?: 'CustomField';
  _id?: Maybe<Scalars['ID']>;
  formField?: Maybe<FormField>;
  value?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DateOperators = {
  after?: InputMaybe<Scalars['DateTime']>;
  before?: InputMaybe<Scalars['DateTime']>;
};

export type DefaultCampaignSettings = {
  __typename?: 'DefaultCampaignSettings';
  color?: Maybe<Scalars['String']>;
  deliveryOptions?: Maybe<DeliveryOptions>;
  headerImgUrl?: Maybe<Scalars['String']>;
  minimumOrderValue?: Maybe<Scalars['Int']>;
  minimumTotalArticleCount?: Maybe<Scalars['Int']>;
  timeslots?: Maybe<Timeslots>;
};

export type DeleteCampaignResponse = {
  __typename?: 'DeleteCampaignResponse';
  status: Scalars['String'];
};

export type DeleteSellerGroupResponse = {
  __typename?: 'DeleteSellerGroupResponse';
  removalDate: Scalars['String'];
};

export type DeleteSellerGroupsResponse = {
  __typename?: 'DeleteSellerGroupsResponse';
  deletedCount: Scalars['Int'];
  rejectedGroups: Array<RejectedSellerGroup>;
};

export type DeliveryCondition = {
  __typename?: 'DeliveryCondition';
  _id: Scalars['ID'];
  condition: Scalars['String'];
  start: Scalars['Int'];
  text?: Maybe<Scalars['String']>;
};

export type DeliveryConditionInput = {
  condition: Scalars['String'];
  start: Scalars['Int'];
  text?: InputMaybe<Scalars['String']>;
};

export type DeliveryInfo = {
  __typename?: 'DeliveryInfo';
  contactPerson: Scalars['String'];
  deliveryAddress?: Maybe<Address>;
  deliveryMethod?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  remarks?: Maybe<Scalars['String']>;
};

export type DeliveryInfoInput = {
  contactPerson: Scalars['String'];
  deliveryAddress?: InputMaybe<InputAddress>;
  deliveryMethod?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  remarks?: InputMaybe<Scalars['String']>;
};

export enum DeliveryMethod {
  Collect = 'collect',
  Deliver = 'deliver',
  EatIn = 'eatIn'
}

export type DeliveryOptions = {
  __typename?: 'DeliveryOptions';
  deliveryCountries?: Maybe<Array<Scalars['String']>>;
  deliveryMethods: Array<DeliveryMethod>;
  deliveryRadii?: Maybe<Array<DeliveryRadius>>;
  minimumTotalPrice?: Maybe<Scalars['Int']>;
  shippingCosts?: Maybe<Scalars['Int']>;
};

export type DeliveryRadius = {
  __typename?: 'DeliveryRadius';
  _id: Scalars['ID'];
  centralAddress?: Maybe<Address>;
  radius?: Maybe<Scalars['Int']>;
};

export type DeliveryRange = {
  __typename?: 'DeliveryRange';
  end?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export type DeliverySettings = {
  __typename?: 'DeliverySettings';
  closingPeriods?: Maybe<Array<Maybe<ClosingPeriod>>>;
  conditions?: Maybe<Array<DeliveryCondition>>;
  maxDeliveryTime: MaxDeliveryTime;
  metric: Scalars['String'];
};

export type DeliverySettingsInput = {
  closingPeriods?: InputMaybe<Array<InputMaybe<ClosingPeriodInput>>>;
  conditions?: InputMaybe<Array<DeliveryConditionInput>>;
  maxDeliveryTime: MaxDeliveryTimeInput;
  metric: Scalars['String'];
};

export type DonationArticle = IArticle & {
  __typename?: 'DonationArticle';
  _id: Scalars['ID'];
  isDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  price: Scalars['Int'];
};

export type EditSellerGroupInput = {
  code: Scalars['String'];
  sellers: Array<SellerInput>;
  tags: Array<InputMaybe<Scalars['String']>>;
};

export type EditSellerGroupResponse = {
  __typename?: 'EditSellerGroupResponse';
  success: Scalars['Boolean'];
};

export type EditSellerGroupTagsResponse = {
  __typename?: 'EditSellerGroupTagsResponse';
  editedItemsCount: Scalars['Int'];
};

export enum ExportOrdersStatus {
  Done = 'done',
  Error = 'error',
  Pending = 'pending',
  TooManyOrders = 'too_many_orders'
}

export type ExternalIdInput = {
  id: Scalars['String'];
  source: Scalars['String'];
};

export type ExtraInfo = {
  __typename?: 'ExtraInfo';
  description: Scalars['String'];
  title: Scalars['String'];
};

export type FormField = {
  __typename?: 'FormField';
  _id: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  isMultiselect?: Maybe<Scalars['Boolean']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  label: Scalars['String'];
  options?: Maybe<Array<Scalars['String']>>;
  placeholder?: Maybe<Scalars['String']>;
  type?: Maybe<FormFieldEnum>;
};

export enum FormFieldEnum {
  Enum = 'enum',
  FreeText = 'free_text'
}

export type FormFieldInput = {
  _id?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  isMultiselect?: InputMaybe<Scalars['Boolean']>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeholder?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FormFieldsSortParameter = {
  key: Scalars['String'];
  sort?: InputMaybe<SortOrder>;
};

export type IArticle = {
  _id: Scalars['ID'];
  isDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  price: Scalars['Int'];
};

export type IPageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type InputAddress = {
  description: Scalars['String'];
};

export type InputTimeslot = {
  badge?: InputMaybe<Scalars['String']>;
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type InsertCampaignInput = {
  articlePackageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  articles?: InputMaybe<Array<UpdateArticleInput>>;
  charityId?: InputMaybe<Scalars['ID']>;
  enabledArticleTemplateIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name: Scalars['String'];
  openGraphTags: UpdateOpenGraphTagsInput;
  referredByCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  showScoreboard?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  tenantExternalId?: InputMaybe<ExternalIdInput>;
  textConfig: InsertTextConfigInput;
};

export type InsertMemberListInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  groupBy?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type InsertOrderInput = {
  address?: InputMaybe<Scalars['String']>;
  collectTimeslot?: InputMaybe<InputTimeslot>;
  customFields?: InputMaybe<Array<OrderCustomFieldsInput>>;
  deliveryMethod?: InputMaybe<DeliveryMethod>;
  email: Scalars['String'];
  name: Scalars['String'];
  quantities: Array<QuantityInput>;
  sellerGroupId?: InputMaybe<Scalars['ID']>;
};

export type InsertOrderResponse = {
  __typename?: 'InsertOrderResponse';
  orderId?: Maybe<Scalars['String']>;
  stripeSessionId?: Maybe<Scalars['String']>;
  stripeSourceRedirectUrl?: Maybe<Scalars['String']>;
};

export type InsertTextConfigInput = {
  confirmationMail: Scalars['String'];
  delivery?: InputMaybe<Scalars['String']>;
  info: Scalars['String'];
  memberMail: Scalars['String'];
  printOrderMessage?: InputMaybe<Scalars['String']>;
  scoreboard: Scalars['String'];
  sellingDisabled: Scalars['String'];
};

export type IntegerOperators = {
  equals?: InputMaybe<Scalars['Int']>;
  lessThan?: InputMaybe<Scalars['Int']>;
  moreThan?: InputMaybe<Scalars['Int']>;
};

export type InterfaceConfig = {
  __typename?: 'InterfaceConfig';
  hideArticleCounter?: Maybe<Scalars['Boolean']>;
  showFirstNamesFirst?: Maybe<Scalars['Boolean']>;
  sortFeatures?: Maybe<Scalars['Boolean']>;
};

export type InviteUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type Invoice = {
  __typename?: 'Invoice';
  _id: Scalars['ID'];
  campaignId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
  invoiceNumber: Scalars['String'];
  receiver: Scalars['ID'];
  totalCommissionExclVAT: Scalars['Int'];
  url: Scalars['String'];
};

export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  edges: Array<InvoiceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  cursor: Scalars['String'];
  node: Invoice;
};

export type InvoiceSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  invoiceNumber?: InputMaybe<SortOrder>;
  totalCommissionExclVAT?: InputMaybe<SortOrder>;
};

export type LandingPageStep = {
  __typename?: 'LandingPageStep';
  description: Scalars['String'];
  title: Scalars['String'];
};

export type LinkOrderResponse = {
  __typename?: 'LinkOrderResponse';
  order: PublicOrder;
  sellerGroup: PublicSellerGroup;
};

export type MailPreviousOrderersResponse = {
  __typename?: 'MailPreviousOrderersResponse';
  scheduledCount: Scalars['Int'];
};

export type MailResponse = {
  __typename?: 'MailResponse';
  errorCount: Scalars['Int'];
  scheduledCount: Scalars['Int'];
};

export type MaxDeliveryTime = {
  __typename?: 'MaxDeliveryTime';
  days: Scalars['Int'];
  metric: Scalars['String'];
};

export type MaxDeliveryTimeInput = {
  days: Scalars['Int'];
  metric: Scalars['String'];
};

export type MemberListInput = {
  __typename?: 'MemberListInput';
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  groupBy?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type Metadata = {
  __typename?: 'Metadata';
  acquisitionChannel?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  memberCount?: Maybe<Scalars['Int']>;
  organisationType?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type MetadataInput = {
  acquisitionChannel: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  memberCount?: InputMaybe<Scalars['Int']>;
  organisationName: Scalars['String'];
  organisationType?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type MultiselectItem = {
  _id: Scalars['ID'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptTerms?: Maybe<TenantUser>;
  campaignsOrdersAsXLSX?: Maybe<CampaignsAsXlsxResponse>;
  completeOnboarding?: Maybe<Tenant>;
  connectStripe: Tenant;
  createStripeSession: InsertOrderResponse;
  deleteCampaign?: Maybe<DeleteCampaignResponse>;
  deleteSellerGroups: DeleteSellerGroupsResponse;
  deleteSellergroup: DeleteSellerGroupResponse;
  duplicateCampaign?: Maybe<Campaign>;
  editSellerGroup: EditSellerGroupResponse;
  editSellerGroupTags: EditSellerGroupTagsResponse;
  initDemoPayment: InsertOrderResponse;
  initStripeBancontactPayment: InsertOrderResponse;
  initStripeCardPayment: InsertOrderResponse;
  insertCampaign: Campaign;
  inviteUser: TenantUser;
  linkOrder: LinkOrderResponse;
  mailOrderers: MailResponse;
  mailPreviousPurchasers?: Maybe<MailPreviousOrderersResponse>;
  mailSellergroups: MailResponse;
  ordersAsPDF: OrdersAsPdfResponse;
  ordersAsXLSX: OrdersAsXlsxResponse;
  removeArticle: RemoveArticleResponse;
  removeArticlePackage: RemoveArticlePackageResponse;
  removeArticleTemplate: RemoveArticleTemplateResponse;
  removeFormField?: Maybe<RemovesFormFieldResponse>;
  removeUser: RemoveUserResponse;
  saveOnboardingSettings?: Maybe<Campaign>;
  saveReview: Campaign;
  setMemberList: SetMemberListResponse;
  signedUrl?: Maybe<SignedUrlResponse>;
  sortArticles?: Maybe<Array<Maybe<Article>>>;
  sortCampaignFields?: Maybe<Array<Maybe<FormField>>>;
  updateCampaign: Campaign;
  updateOrder: AdminOrder;
  updatePartnerI18n: Partner;
  updateTenant: Tenant;
  upsertArticle: Article;
  upsertArticlePackage?: Maybe<ArticlePackage>;
  upsertArticleTemplate: ArticleTemplate;
  upsertFormField: FormField;
};


export type MutationCampaignsOrdersAsXlsxArgs = {
  filter?: InputMaybe<CampaignFilterParameter>;
  selectionOptions?: InputMaybe<SelectionOptions>;
};


export type MutationCompleteOnboardingArgs = {
  newTenant: OnboardingInputData;
};


export type MutationConnectStripeArgs = {
  authorizationCode: Scalars['String'];
};


export type MutationCreateStripeSessionArgs = {
  order?: InputMaybe<InsertOrderInput>;
  orderId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};


export type MutationDeleteCampaignArgs = {
  campaignId: Scalars['ID'];
};


export type MutationDeleteSellerGroupsArgs = {
  campaignId: Scalars['ID'];
  filter?: InputMaybe<SellerGroupFilterParameter>;
  selectionOptions: SelectionOptions;
};


export type MutationDeleteSellergroupArgs = {
  _id: Scalars['ID'];
};


export type MutationDuplicateCampaignArgs = {
  campaignId: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};


export type MutationEditSellerGroupArgs = {
  _id: Scalars['ID'];
  campaignId: Scalars['ID'];
  newData: EditSellerGroupInput;
};


export type MutationEditSellerGroupTagsArgs = {
  campaignId: Scalars['ID'];
  filter?: InputMaybe<SellerGroupFilterParameter>;
  newTags: Array<InputMaybe<Scalars['String']>>;
  selectionOptions: SelectionOptions;
};


export type MutationInitDemoPaymentArgs = {
  order?: InputMaybe<InsertOrderInput>;
  orderId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};


export type MutationInitStripeBancontactPaymentArgs = {
  order?: InputMaybe<InsertOrderInput>;
  orderId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};


export type MutationInitStripeCardPaymentArgs = {
  order?: InputMaybe<InsertOrderInput>;
  orderId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};


export type MutationInsertCampaignArgs = {
  campaign: InsertCampaignInput;
};


export type MutationInviteUserArgs = {
  inviteUser?: InputMaybe<InviteUserInput>;
};


export type MutationLinkOrderArgs = {
  orderId: Scalars['ID'];
  sellerGroupId: Scalars['ID'];
};


export type MutationMailOrderersArgs = {
  body: Scalars['String'];
  filter: OrderFilterParameter;
  selectionOptions: SelectionOptions;
  subject: Scalars['String'];
};


export type MutationMailPreviousPurchasersArgs = {
  body: Scalars['String'];
  campaignId: Scalars['ID'];
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  subject: Scalars['String'];
};


export type MutationMailSellergroupsArgs = {
  body: Scalars['String'];
  campaignId: Scalars['ID'];
  filter?: InputMaybe<SellerGroupFilterParameter>;
  selectionOptions: SelectionOptions;
  subject: Scalars['String'];
};


export type MutationOrdersAsPdfArgs = {
  filter: OrderFilterParameter;
  printOrderMessage?: InputMaybe<Scalars['String']>;
  selectionOptions: SelectionOptions;
  sort?: InputMaybe<Array<InputMaybe<FormFieldsSortParameter>>>;
};


export type MutationOrdersAsXlsxArgs = {
  filter: OrderFilterParameter;
  selectionOptions: SelectionOptions;
  sortByAddress?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRemoveArticleArgs = {
  article: RemoveArticleInput;
};


export type MutationRemoveArticlePackageArgs = {
  articlePackage: RemoveArticlePackagesInput;
};


export type MutationRemoveArticleTemplateArgs = {
  articleTemplate: RemoveArticleTemplateInput;
};


export type MutationRemoveFormFieldArgs = {
  formField: FormFieldInput;
};


export type MutationRemoveUserArgs = {
  removeUser?: InputMaybe<RemoveUserInput>;
};


export type MutationSaveOnboardingSettingsArgs = {
  campaignId: Scalars['ID'];
  settings: OnboardingSettingsInput;
};


export type MutationSaveReviewArgs = {
  campaignId: Scalars['ID'];
  review: PartnerReviewInput;
};


export type MutationSetMemberListArgs = {
  campaignId: Scalars['ID'];
  data: Array<InsertMemberListInput>;
  overwrite?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSortArticlesArgs = {
  _ids?: InputMaybe<Array<Scalars['ID']>>;
  campaignId: Scalars['ID'];
};


export type MutationSortCampaignFieldsArgs = {
  _ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationUpdateCampaignArgs = {
  campaign: UpdateCampaignInput;
};


export type MutationUpdateOrderArgs = {
  order: UpdateOrderInput;
};


export type MutationUpdatePartnerI18nArgs = {
  i18n: UpdatePartnerI18nInput;
};


export type MutationUpdateTenantArgs = {
  tenant?: InputMaybe<UpdateTenantInput>;
};


export type MutationUpsertArticleArgs = {
  article: UpdateArticleInput;
  campaignId: Scalars['ID'];
};


export type MutationUpsertArticlePackageArgs = {
  articlePackage: UpsertArticlePackagesInput;
};


export type MutationUpsertArticleTemplateArgs = {
  articleTemplate: UpdateArticleTemplateInput;
};


export type MutationUpsertFormFieldArgs = {
  campaignId: Scalars['ID'];
  formField: FormFieldInput;
};

export enum NotificationSetting {
  Instant = 'instant'
}

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  campaignAutoClosed?: Maybe<NotificationSetting>;
  campaignFirstOrder?: Maybe<NotificationSetting>;
  deliveryReminder?: Maybe<NotificationSetting>;
  newCampaign?: Maybe<NotificationSetting>;
  orders?: Maybe<NotificationSetting>;
  requestedDeliveryDateUpdate?: Maybe<NotificationSetting>;
};

export type NotificationSettingsInput = {
  campaignAutoClosed?: InputMaybe<NotificationSetting>;
  campaignFirstOrder?: InputMaybe<NotificationSetting>;
  deliveryReminder?: InputMaybe<NotificationSetting>;
  newCampaign?: InputMaybe<NotificationSetting>;
  orders?: InputMaybe<NotificationSetting>;
  requestedDeliveryDateUpdate?: InputMaybe<NotificationSetting>;
};

export type OnboardingInputData = {
  _type: Scalars['String'];
  acquisition?: InputMaybe<AcquisitionInput>;
  billingDetails?: InputMaybe<BillingDetailsInput>;
  locale: Scalars['String'];
  metadata: MetadataInput;
  referredByCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OnboardingSettings = {
  __typename?: 'OnboardingSettings';
  _id?: Maybe<Scalars['ID']>;
  closeAt?: Maybe<Scalars['String']>;
  confirmedDeliveryRange?: Maybe<DeliveryRange>;
  deliveryInfo?: Maybe<DeliveryInfo>;
  isEmailSent?: Maybe<Scalars['Boolean']>;
  isOrdersXLSXDownloaded?: Maybe<Scalars['Boolean']>;
  isPreviousPurchaserMailed?: Maybe<Scalars['Boolean']>;
  isReminderSent?: Maybe<Scalars['Boolean']>;
  needsDeliver?: Maybe<Scalars['Boolean']>;
  needsTimeslots?: Maybe<Scalars['Boolean']>;
  requestedDeliveryDate?: Maybe<Scalars['String']>;
  shareChecklist?: Maybe<Array<Maybe<ShareChecklistType>>>;
  stepsToSkip?: Maybe<Array<Maybe<Scalars['String']>>>;
  stripeType?: Maybe<Scalars['String']>;
};

export type OnboardingSettingsInput = {
  closeAt?: InputMaybe<Scalars['String']>;
  confirmedDeliveryRange?: InputMaybe<ConfirmedDeliveryRangeInput>;
  deliveryInfo?: InputMaybe<DeliveryInfoInput>;
  isEmailSent?: InputMaybe<Scalars['Boolean']>;
  isReminderSent?: InputMaybe<Scalars['Boolean']>;
  needsDeliver?: InputMaybe<Scalars['Boolean']>;
  needsTimeslots?: InputMaybe<Scalars['Boolean']>;
  requestedDeliveryDate?: InputMaybe<Scalars['String']>;
  shareChecklist?: InputMaybe<Array<InputMaybe<ShareChecklistInput>>>;
  stepsToSkip?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stripeType?: InputMaybe<Scalars['String']>;
};

export type OpenGraphTags = {
  __typename?: 'OpenGraphTags';
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type OptimalRouteResponse = {
  __typename?: 'OptimalRouteResponse';
  redirectUrl?: Maybe<Scalars['String']>;
};

export type OrderConnection = {
  __typename?: 'OrderConnection';
  edges: Array<OrderEdge>;
  pageInfo: PageInfo;
  possibleFilters?: Maybe<OrderPossibleFilters>;
  totalCount: Scalars['Int'];
};

export type OrderCustomFieldsInput = {
  formField: Scalars['ID'];
  value?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OrderEdge = {
  __typename?: 'OrderEdge';
  cursor: Scalars['String'];
  node: AdminOrder;
};

export type OrderFilterParameter = {
  _id?: InputMaybe<StringOperators>;
  campaignId: Scalars['ID'];
  collectTimeslot?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  deliveryMethod?: InputMaybe<StringOperators>;
  isDelivered?: InputMaybe<BooleanOperators>;
  paymentStatus?: InputMaybe<StringOperators>;
  postalCode?: InputMaybe<StringOperators>;
  sellerName?: InputMaybe<StringOperators>;
  textSearch?: InputMaybe<Scalars['String']>;
};

export type OrderPossibleFilters = {
  __typename?: 'OrderPossibleFilters';
  collectTimeslot?: Maybe<Array<StringPossibleFilter>>;
  postalCode?: Maybe<Array<StringPossibleFilter>>;
};

export type OrderSortParameter = {
  address?: InputMaybe<SortOrder>;
  amountPaid?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  collectTimeslot?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  formFields?: InputMaybe<FormFieldsSortParameter>;
  isDelivered?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  paymentStatus?: InputMaybe<SortOrder>;
  sellerGroup?: InputMaybe<SortOrder>;
};

export type OrdersAsPdfResponse = {
  __typename?: 'OrdersAsPDFResponse';
  status: ExportOrdersStatus;
  url?: Maybe<Scalars['String']>;
};

export type OrdersAsXlsxResponse = {
  __typename?: 'OrdersAsXLSXResponse';
  status: ExportOrdersStatus;
  url?: Maybe<Scalars['String']>;
};

export type OrdersSummaryResponse = {
  __typename?: 'OrdersSummaryResponse';
  addressExists?: Maybe<Scalars['Boolean']>;
  sellerGroupExists?: Maybe<Scalars['Boolean']>;
};

export type Organisation = Tenant & {
  __typename?: 'Organisation';
  _id: Scalars['ID'];
  analytics?: Maybe<TenantAnalytics>;
  billingDetails?: Maybe<BillingDetails>;
  campaigns?: Maybe<CampaignConnection>;
  email: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  name: Scalars['String'];
  notificationSettings?: Maybe<NotificationSettings>;
  organisationType?: Maybe<Scalars['String']>;
  permissions: Array<Scalars['String']>;
  referralCode?: Maybe<Scalars['String']>;
  referralProfile?: Maybe<Scalars['String']>;
  stripeAccount?: Maybe<StripeAccount>;
  useLegacyBancontact?: Maybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};


export type OrganisationAnalyticsArgs = {
  lastXDays?: InputMaybe<Scalars['Int']>;
};


export type OrganisationCampaignsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<CampaignFilterParameter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<CampaignSortParameter>;
};

export type PageInfo = IPageInfo & {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type Partner = Tenant & {
  __typename?: 'Partner';
  _id: Scalars['ID'];
  aboutImgUrl?: Maybe<Scalars['String']>;
  analytics?: Maybe<TenantAnalytics>;
  articlePackages?: Maybe<Array<Maybe<ArticlePackage>>>;
  articleTemplates: Array<ArticleTemplate>;
  billingDetails?: Maybe<BillingDetails>;
  campaigns?: Maybe<CampaignConnection>;
  deliverySettings?: Maybe<DeliverySettings>;
  email: Scalars['String'];
  finishCampaignInstructions?: Maybe<Scalars['String']>;
  i18n: Array<Maybe<PartnerI18n>>;
  landingPageSteps?: Maybe<Array<Maybe<LandingPageStep>>>;
  locale?: Maybe<Scalars['String']>;
  longDescription?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  name: Scalars['String'];
  notificationSettings?: Maybe<NotificationSettings>;
  permissions: Array<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  referralProfile?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  stripeAccount?: Maybe<StripeAccount>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  unfinishedCampaignCount?: Maybe<Scalars['Int']>;
  userId: Scalars['String'];
  webhooks?: Maybe<Array<Maybe<Webhook>>>;
};


export type PartnerAboutImgUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


export type PartnerAnalyticsArgs = {
  lastXDays?: InputMaybe<Scalars['Int']>;
};


export type PartnerArticleTemplatesArgs = {
  first?: InputMaybe<Scalars['Int']>;
  lang?: InputMaybe<Scalars['String']>;
};


export type PartnerCampaignsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<CampaignFilterParameter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<CampaignSortParameter>;
};


export type PartnerDeliverySettingsArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


export type PartnerFinishCampaignInstructionsArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


export type PartnerLongDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


export type PartnerNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


export type PartnerShortDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


export type PartnerSlugArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type PartnerI18n = {
  __typename?: 'PartnerI18n';
  aboutImgUrl?: Maybe<Scalars['String']>;
  deliverySettings?: Maybe<DeliverySettings>;
  finishCampaignInstructions?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  longDescription?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  shortDescription?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type PartnerReview = {
  __typename?: 'PartnerReview';
  _id?: Maybe<Scalars['ID']>;
  communication?: Maybe<Scalars['Int']>;
  delivery?: Maybe<Scalars['Int']>;
  overallFeedback?: Maybe<Scalars['String']>;
  partnerResponse?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['Int']>;
  recommendation?: Maybe<Scalars['Int']>;
};

export type PartnerReviewInput = {
  communication?: InputMaybe<Scalars['Int']>;
  delivery?: InputMaybe<Scalars['Int']>;
  overallFeedback?: InputMaybe<Scalars['String']>;
  partnerResponse?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Scalars['Int']>;
  recommendation?: InputMaybe<Scalars['Int']>;
};

export type PerArticle = {
  __typename?: 'PerArticle';
  articleId: Scalars['String'];
  articleName: Scalars['String'];
  articlePrices: Array<Scalars['Int']>;
  articlePurchasePrices: Array<Maybe<Scalars['Int']>>;
  totalCount: Scalars['Int'];
  totalPurchasePrice: Scalars['Int'];
  totalValue: Scalars['Int'];
};

export type PerDay = {
  __typename?: 'PerDay';
  day: Scalars['Int'];
  month: Scalars['Int'];
  totalCount: Scalars['Int'];
  totalValue: Scalars['Int'];
  year: Scalars['Int'];
};

export type ProfitMargins = {
  __typename?: 'ProfitMargins';
  avgAbsolute: Scalars['Float'];
  avgRelative: Scalars['Float'];
  maxAbsolute: Scalars['Float'];
  maxRelative: Scalars['Float'];
  minAbsolute: Scalars['Float'];
  minRelative: Scalars['Float'];
};

export type PublicOrder = {
  __typename?: 'PublicOrder';
  _id: Scalars['ID'];
  cardsCount?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  datePaid?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  paymentStatus?: Maybe<Scalars['String']>;
  quantities?: Maybe<Array<Maybe<Quantity>>>;
  sellerGroup?: Maybe<PublicSellerGroup>;
};

export type PublicSellerGroup = {
  __typename?: 'PublicSellerGroup';
  _id: Scalars['ID'];
  code: Scalars['String'];
  link: Scalars['String'];
  names: Scalars['String'];
  offset: Scalars['Int'];
  orders: Array<SecretPublicOrder>;
  points: Scalars['Int'];
  position: Scalars['Int'];
  sellers?: Maybe<Array<Seller>>;
  tags: Array<Maybe<Scalars['String']>>;
};

export type Quantity = {
  __typename?: 'Quantity';
  article: IArticle;
  price: Scalars['Int'];
  quantity: Scalars['Int'];
};

export type QuantityInput = {
  articleId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  adminCampaignById?: Maybe<Campaign>;
  adminOrderById?: Maybe<AdminOrder>;
  articlePackage?: Maybe<ArticlePackage>;
  articlePackageTags: Array<Maybe<ArticlePackageTag>>;
  articlePackages: Array<Maybe<ArticlePackage>>;
  articleTemplates: Array<Maybe<ArticleTemplate>>;
  campaign?: Maybe<Campaign>;
  campaignBySlug?: Maybe<Campaign>;
  campaignConnection?: Maybe<CampaignConnection>;
  campaignsSummary: CampaignAnalytics;
  currentUser?: Maybe<TenantUser>;
  getTenantTags: TenantTags;
  intercomUserHash?: Maybe<Scalars['String']>;
  invoiceConnection?: Maybe<InvoiceConnection>;
  optimalRoute?: Maybe<OptimalRouteResponse>;
  orderByCode?: Maybe<PublicOrder>;
  orderById?: Maybe<PublicOrder>;
  orderConnection?: Maybe<OrderConnection>;
  ordersDataSummary?: Maybe<OrdersSummaryResponse>;
  partnerBySlug?: Maybe<Partner>;
  partners: Array<Partner>;
  permissions: Array<Scalars['String']>;
  routeStops?: Maybe<Array<RouteStop>>;
  scoreboard?: Maybe<Array<Maybe<PublicSellerGroup>>>;
  sellerGroup: PublicSellerGroup;
  sellerGroupConnection?: Maybe<SellerGroupConnection>;
  tenant?: Maybe<Tenant>;
  tenantUsers?: Maybe<Array<Maybe<TenantUser>>>;
  tenants: Array<Tenant>;
  uniquePurchasersLastOrderIds?: Maybe<UniquePurchasersResponse>;
  whitelabel?: Maybe<Whitelabel>;
};


export type QueryAdminCampaignByIdArgs = {
  _id: Scalars['ID'];
};


export type QueryAdminOrderByIdArgs = {
  _id: Scalars['ID'];
};


export type QueryArticlePackageArgs = {
  _id: Scalars['ID'];
};


export type QueryArticlePackagesArgs = {
  locale?: InputMaybe<Scalars['String']>;
  textSearch?: InputMaybe<Scalars['String']>;
};


export type QueryArticleTemplatesArgs = {
  lang?: InputMaybe<Scalars['String']>;
};


export type QueryCampaignArgs = {
  _id?: InputMaybe<Scalars['ID']>;
};


export type QueryCampaignBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCampaignConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCampaignsSummaryArgs = {
  filter?: InputMaybe<CampaignFilterParameter>;
  selectionOptions: SelectionOptions;
};


export type QueryInvoiceConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<InvoiceSortParameter>;
};


export type QueryOptimalRouteArgs = {
  addresses: Array<Scalars['String']>;
};


export type QueryOrderByCodeArgs = {
  code: Scalars['String'];
  slug: Scalars['String'];
};


export type QueryOrderByIdArgs = {
  _id: Scalars['ID'];
};


export type QueryOrderConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<OrderFilterParameter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<OrderSortParameter>;
};


export type QueryOrdersDataSummaryArgs = {
  filter?: InputMaybe<OrderFilterParameter>;
  selectionOptions?: InputMaybe<SelectionOptions>;
};


export type QueryPartnerBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryPartnersArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']>;
};


export type QueryRouteStopsArgs = {
  campaignId: Scalars['ID'];
  routeStopIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryScoreboardArgs = {
  include0score?: InputMaybe<Scalars['Boolean']>;
  refresh?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
};


export type QuerySellerGroupArgs = {
  secret: Scalars['String'];
  slug: Scalars['String'];
};


export type QuerySellerGroupConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  filter?: InputMaybe<SellerGroupFilterParameter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SellerGroupSortParameter>;
};


export type QueryTenantsArgs = {
  textSearch?: InputMaybe<Scalars['String']>;
};


export type QueryUniquePurchasersLastOrderIdsArgs = {
  campaignIds: Array<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type RejectedSellerGroup = {
  __typename?: 'RejectedSellerGroup';
  _id: Scalars['ID'];
  hasOrders: Scalars['Boolean'];
  sellers: Array<Seller>;
};

export type RemoveArticleInput = {
  _id: Scalars['ID'];
};

export type RemoveArticlePackageResponse = {
  __typename?: 'RemoveArticlePackageResponse';
  status: Scalars['String'];
};

export type RemoveArticlePackagesInput = {
  _id: Scalars['ID'];
};

export type RemoveArticleResponse = {
  __typename?: 'RemoveArticleResponse';
  status: Scalars['String'];
};

export type RemoveArticleTemplateInput = {
  _id: Scalars['ID'];
};

export type RemoveArticleTemplateResponse = {
  __typename?: 'RemoveArticleTemplateResponse';
  status: Scalars['String'];
};

export type RemoveUserInput = {
  userId: Scalars['String'];
};

export type RemoveUserResponse = {
  __typename?: 'RemoveUserResponse';
  status: Scalars['String'];
};

export type RemovesFormFieldResponse = {
  __typename?: 'RemovesFormFieldResponse';
  status: Scalars['String'];
};

export type RouteStop = {
  __typename?: 'RouteStop';
  _id: Scalars['ID'];
  address: Address;
  names: Scalars['String'];
  orderIds: Array<Maybe<Scalars['ID']>>;
  quantities: Array<Maybe<Quantity>>;
};

export type SecretPublicOrder = {
  __typename?: 'SecretPublicOrder';
  _id: Scalars['ID'];
  address?: Maybe<Address>;
  amountPaid?: Maybe<Scalars['Int']>;
  cardsCount?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  collectTimeslot?: Maybe<Timeslot>;
  customFields?: Maybe<Array<CustomField>>;
  datePaid?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  email?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentStatus?: Maybe<Scalars['String']>;
  quantities: Array<Quantity>;
  sellerGroup?: Maybe<PublicSellerGroup>;
};

export type SelectionOptions = {
  excludedItems?: InputMaybe<Array<InputMaybe<MultiselectItem>>>;
  selectedAll?: InputMaybe<Scalars['Boolean']>;
  selectedItems?: InputMaybe<Array<InputMaybe<MultiselectItem>>>;
};

export type Seller = {
  __typename?: 'Seller';
  _id: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
};

export type SellerGroupConnection = {
  __typename?: 'SellerGroupConnection';
  edges: Array<SellerGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SellerGroupEdge = {
  __typename?: 'SellerGroupEdge';
  cursor: Scalars['String'];
  node: AdminSellerGroup;
};

export type SellerGroupFilterParameter = {
  facebookShares?: InputMaybe<IntegerOperators>;
  firstName?: InputMaybe<StringOperators>;
  lastName?: InputMaybe<StringOperators>;
  link?: InputMaybe<StringOperators>;
  orderValue?: InputMaybe<IntegerOperators>;
  tag?: InputMaybe<StringOperators>;
  textSearch?: InputMaybe<Scalars['String']>;
};

export type SellerGroupInput = {
  _id: Scalars['String'];
};

export type SellerGroupSortParameter = {
  code?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  facebookShares?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  orderValue?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
};

export type SellerInput = {
  _id?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type SetMemberListResponse = {
  __typename?: 'SetMemberListResponse';
  added: Array<AdminSellerGroup>;
  duplicates: Array<MemberListInput>;
};

export type ShareChecklistInput = {
  _id?: InputMaybe<Scalars['ID']>;
  isDone?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
};

export type ShareChecklistType = {
  __typename?: 'ShareChecklistType';
  _id?: Maybe<Scalars['ID']>;
  isDone?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
};

export type ShippingCostsArticle = IArticle & {
  __typename?: 'ShippingCostsArticle';
  _id: Scalars['ID'];
  isDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  price: Scalars['Int'];
};

export type SignedUrlResponse = {
  __typename?: 'SignedUrlResponse';
  apiKey: Scalars['String'];
  cloudName: Scalars['String'];
  signature: Scalars['String'];
  timestamp: Scalars['Int'];
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringOperators = {
  contains?: InputMaybe<Scalars['String']>;
  doesNotContain?: InputMaybe<Scalars['String']>;
  hasValue?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  is?: InputMaybe<Scalars['String']>;
  isEmpty?: InputMaybe<Scalars['String']>;
  isNot?: InputMaybe<Scalars['String']>;
};

export type StringPossibleFilter = {
  __typename?: 'StringPossibleFilter';
  label: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type StripeAccount = {
  __typename?: 'StripeAccount';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type SuggestedDeliveryDate = {
  __typename?: 'SuggestedDeliveryDate';
  closingPeriod?: Maybe<ClosingPeriod>;
  date: Scalars['String'];
};

export type Tenant = {
  _id: Scalars['ID'];
  analytics?: Maybe<TenantAnalytics>;
  billingDetails?: Maybe<BillingDetails>;
  campaigns?: Maybe<CampaignConnection>;
  email: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  name: Scalars['String'];
  notificationSettings?: Maybe<NotificationSettings>;
  referralProfile?: Maybe<Scalars['String']>;
  stripeAccount?: Maybe<StripeAccount>;
  userId: Scalars['String'];
};


export type TenantAnalyticsArgs = {
  lastXDays?: InputMaybe<Scalars['Int']>;
};


export type TenantCampaignsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<CampaignFilterParameter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<CampaignSortParameter>;
};

export type TenantAnalytics = {
  __typename?: 'TenantAnalytics';
  allTimeAvgOrderValue: Scalars['Int'];
  allTimeCharityRevenue?: Maybe<Scalars['Int']>;
  allTimeOrderCount: Scalars['Int'];
  allTimeOrderTurnover?: Maybe<Scalars['Int']>;
  allTimeOrganisationCommission?: Maybe<Scalars['Int']>;
  allTimeOrganisationRevenue?: Maybe<Scalars['Int']>;
  allTimePartnerCommission?: Maybe<Scalars['Int']>;
  allTimePartnerRevenue?: Maybe<Scalars['Int']>;
  allTimeReferralRevenue: Scalars['Int'];
  perArticle?: Maybe<Array<Maybe<PerArticle>>>;
  perDay?: Maybe<Array<Maybe<PerDay>>>;
};

export type TenantTags = {
  __typename?: 'TenantTags';
  tenantTags: Array<Maybe<Scalars['String']>>;
};

export type TenantUser = {
  __typename?: 'TenantUser';
  _id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastAcceptedTerms?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
};

export type TextConfig = {
  __typename?: 'TextConfig';
  addressLabel?: Maybe<Scalars['String']>;
  confirmationMail: Scalars['String'];
  delivery?: Maybe<Scalars['String']>;
  deliveryLabel?: Maybe<Scalars['String']>;
  emailDescription?: Maybe<Scalars['String']>;
  emailLabel?: Maybe<Scalars['String']>;
  info: Scalars['String'];
  introduction?: Maybe<Scalars['String']>;
  memberMail: Scalars['String'];
  nameDescription?: Maybe<Scalars['String']>;
  nameLabel?: Maybe<Scalars['String']>;
  printOrderMessage?: Maybe<Scalars['String']>;
  scoreboard: Scalars['String'];
  sellerGroupDescription?: Maybe<Scalars['String']>;
  sellerGroupLabel?: Maybe<Scalars['String']>;
  sellerGroupPlaceholder?: Maybe<Scalars['String']>;
  sellingDisabled: Scalars['String'];
  variantUnavailable?: Maybe<Scalars['String']>;
};

export type Timeslot = {
  __typename?: 'Timeslot';
  badge?: Maybe<Scalars['String']>;
  end: Scalars['DateTime'];
  isDisabled?: Maybe<Scalars['Boolean']>;
  maxCount?: Maybe<Scalars['Int']>;
  orderCount?: Maybe<Scalars['Int']>;
  start: Scalars['DateTime'];
};

export type Timeslots = {
  __typename?: 'Timeslots';
  collect?: Maybe<Array<Timeslot>>;
  deliver?: Maybe<Array<Timeslot>>;
  eatIn?: Maybe<Array<Timeslot>>;
};

export type UniquePurchasersResponse = {
  __typename?: 'UniquePurchasersResponse';
  orderIds: Array<Maybe<Scalars['ID']>>;
  purchaserCount: Scalars['Int'];
};

export type UpdateArticleInput = {
  _id?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  imageUrls?: InputMaybe<Array<Scalars['String']>>;
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  itemsLeft?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
};

export type UpdateArticleTemplateInput = {
  _id?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  imageUrls?: InputMaybe<Array<Scalars['String']>>;
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  lang?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  purchasePrice?: InputMaybe<Scalars['Int']>;
  requiredOrderMultiple?: InputMaybe<Scalars['Int']>;
  sellingPrice?: InputMaybe<Scalars['Int']>;
};

export type UpdateCampaignInput = {
  _id: Scalars['ID'];
  acceptDonations?: InputMaybe<Scalars['Boolean']>;
  articles?: InputMaybe<Array<UpdateArticleInput>>;
  charityId?: InputMaybe<Scalars['ID']>;
  codeGenerationMethod?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  deliveryOptions?: InputMaybe<UpdateDeliveryOptions>;
  headerImgUrl?: InputMaybe<Scalars['String']>;
  isSellerGroupReadOnly?: InputMaybe<Scalars['Boolean']>;
  isSellerGroupRequired?: InputMaybe<Scalars['Boolean']>;
  isSellingEnabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  openGraphTags?: InputMaybe<UpdateOpenGraphTagsInput>;
  showFullLastnames?: InputMaybe<Scalars['Boolean']>;
  showScoreboard?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  textConfig?: InputMaybe<UpdateTextConfigInput>;
  timeslots?: InputMaybe<UpdateTimeslots>;
  winnerCount?: InputMaybe<Scalars['Int']>;
};

export type UpdateDeliveryOptions = {
  deliveryMethods?: InputMaybe<Array<InputMaybe<DeliveryMethod>>>;
  deliveryRadii?: InputMaybe<Array<UpdateDeliveryRadius>>;
  minimumTotalPrice?: InputMaybe<Scalars['Int']>;
  shippingCosts?: InputMaybe<Scalars['Int']>;
};

export type UpdateDeliveryRadius = {
  centralAddress?: InputMaybe<Scalars['String']>;
  radius?: InputMaybe<Scalars['Int']>;
};

export type UpdateOpenGraphTagsInput = {
  description: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type UpdateOrderInput = {
  address?: InputMaybe<InputAddress>;
  collectTimeslot?: InputMaybe<InputTimeslot>;
  customFields?: InputMaybe<Array<OrderCustomFieldsInput>>;
  deliveryMethod?: InputMaybe<DeliveryMethod>;
  email?: InputMaybe<Scalars['String']>;
  isDelivered?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  sellerGroupId?: InputMaybe<Scalars['ID']>;
};

export type UpdatePartnerI18nInput = {
  aboutImgUrl?: InputMaybe<Scalars['String']>;
  deliverySettings?: InputMaybe<DeliverySettingsInput>;
  finishCampaignInstructions?: InputMaybe<Scalars['String']>;
  locale: Scalars['String'];
  longDescription?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  shortDescription?: InputMaybe<Scalars['String']>;
};

export type UpdateTenantInput = {
  billingDetails?: InputMaybe<BillingDetailsInput>;
  email?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<NotificationSettingsInput>;
};

export type UpdateTextConfigInput = {
  confirmationMail?: InputMaybe<Scalars['String']>;
  delivery?: InputMaybe<Scalars['String']>;
  info?: InputMaybe<Scalars['String']>;
  memberMail?: InputMaybe<Scalars['String']>;
  printOrderMessage?: InputMaybe<Scalars['String']>;
  scoreboard?: InputMaybe<Scalars['String']>;
  sellerGroupDescription?: InputMaybe<Scalars['String']>;
  sellerGroupLabel?: InputMaybe<Scalars['String']>;
  sellerGroupPlaceholder?: InputMaybe<Scalars['String']>;
  sellingDisabled?: InputMaybe<Scalars['String']>;
};

export type UpdateTimeslot = {
  badge?: InputMaybe<Scalars['String']>;
  end: Scalars['DateTime'];
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  maxCount?: InputMaybe<Scalars['Int']>;
  start: Scalars['DateTime'];
};

export type UpdateTimeslots = {
  collect?: InputMaybe<Array<UpdateTimeslot>>;
  deliver?: InputMaybe<Array<UpdateTimeslot>>;
  eatIn?: InputMaybe<Array<UpdateTimeslot>>;
};

export type UpsertArticlePackagesInput = {
  _id?: InputMaybe<Scalars['ID']>;
  articleTemplateIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  description?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  locales: Array<InputMaybe<Scalars['String']>>;
  name: Scalars['String'];
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type Webhook = {
  __typename?: 'Webhook';
  _id: Scalars['ID'];
  triggers?: Maybe<Array<Maybe<WebhookTrigger>>>;
  webhookUrl: Scalars['String'];
};

export enum WebhookTrigger {
  NewInvoice = 'new_invoice',
  PartnerCampaignAutoClosed = 'partner_campaign_auto_closed',
  PartnerCampaignInserted = 'partner_campaign_inserted',
  PartnerCampaignRequestedDeliveryDateUpdated = 'partner_campaign_requested_delivery_date_updated',
  PartnerOrderPlaced = 'partner_order_placed'
}

export type Whitelabel = {
  __typename?: 'Whitelabel';
  _id?: Maybe<Scalars['ID']>;
  colors?: Maybe<WhitelabelColor>;
  domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  footer?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type WhitelabelColor = {
  __typename?: 'WhitelabelColor';
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
};

export type DeleteSellerGroupMutationVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type DeleteSellerGroupMutation = { __typename?: 'Mutation', deleteSellergroup: { __typename?: 'DeleteSellerGroupResponse', removalDate: string } };

export type OrderMutationMutationVariables = Exact<{
  slug: Scalars['String'];
  order?: InputMaybe<InsertOrderInput>;
  orderId?: InputMaybe<Scalars['String']>;
}>;


export type OrderMutationMutation = { __typename?: 'Mutation', createStripeSession: { __typename?: 'InsertOrderResponse', stripeSessionId?: string | null } };

export type ArticlePackageQueryVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type ArticlePackageQuery = { __typename?: 'Query', articlePackage?: { __typename?: 'ArticlePackage', _id: string, slug: string, name: string, locales?: Array<string | null> | null, articleTemplates: Array<{ __typename?: 'ArticleTemplate', _id: string, imageUrls?: Array<string> | null, name: string, sellingPrice: number, description?: string | null, groupId?: string | null, extraInfo?: Array<{ __typename?: 'ExtraInfo', title: string, description: string }> | null, features?: Array<{ __typename?: 'ArticleFeature', key: string, value: string }> | null }>, defaultCampaignSettings?: { __typename?: 'DefaultCampaignSettings', headerImgUrl?: string | null, color?: string | null, minimumTotalArticleCount?: number | null, minimumOrderValue?: number | null, deliveryOptions?: { __typename?: 'DeliveryOptions', deliveryMethods: Array<DeliveryMethod> } | null } | null, partner: { __typename?: 'Partner', locale?: string | null } } | null };

export type CampaignQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type CampaignQuery = { __typename?: 'Query', campaignBySlug?: { __typename?: 'Campaign', slug: string, name: string, headerImgUrl?: string | null, isSellingEnabled: boolean, minimumTotalArticleCount?: number | null, minimumOrderValue?: number | null, isSellerGroupRequired?: boolean | null, showScoreboard: boolean, winnerCount?: number | null, acceptDonations?: boolean | null, onlyFinalOrderAllowed: boolean, textConfig?: { __typename?: 'TextConfig', deliveryLabel?: string | null, emailLabel?: string | null, emailDescription?: string | null, nameLabel?: string | null, nameDescription?: string | null, sellerGroupLabel?: string | null, sellerGroupDescription?: string | null, sellerGroupPlaceholder?: string | null, addressLabel?: string | null, scoreboard: string, info: string, sellingDisabled: string, variantUnavailable?: string | null, delivery?: string | null } | null, openGraphTags?: { __typename?: 'OpenGraphTags', title?: string | null, description?: string | null, imageUrl?: string | null } | null, articles?: Array<{ __typename?: 'Article', imageUrls?: Array<string> | null, description?: string | null, itemsLeft?: number | null, groupId?: string | null, heading?: string | null, _id: string, name: string, price: number, features?: Array<{ __typename?: 'ArticleFeature', key: string, value: string, type?: string | null, label?: string | null }> | null } | { __typename?: 'DonationArticle', _id: string, name: string, price: number } | { __typename?: 'ShippingCostsArticle', _id: string, name: string, price: number }> | null, deliveryOptions: { __typename?: 'DeliveryOptions', deliveryMethods: Array<DeliveryMethod>, deliveryCountries?: Array<string> | null, minimumTotalPrice?: number | null, deliveryRadii?: Array<{ __typename?: 'DeliveryRadius', radius?: number | null, centralAddress?: { __typename?: 'Address', description: string, coordinates?: Array<number | null> | null } | null }> | null }, organisation?: { __typename?: 'Organisation', locale?: string | null } | null, formFields?: Array<{ __typename?: 'FormField', _id: string, label: string, description?: string | null, placeholder?: string | null, isRequired?: boolean | null, isMultiselect?: boolean | null, isDisabled?: boolean | null, options?: Array<string> | null, type?: FormFieldEnum | null }> | null, timeslots?: { __typename?: 'Timeslots', collect?: Array<{ __typename?: 'Timeslot', start: any, end: any, badge?: string | null, isDisabled?: boolean | null }> | null, deliver?: Array<{ __typename?: 'Timeslot', start: any, end: any, badge?: string | null, isDisabled?: boolean | null }> | null, eatIn?: Array<{ __typename?: 'Timeslot', start: any, end: any, badge?: string | null, isDisabled?: boolean | null }> | null } | null, interfaceConfig?: { __typename?: 'InterfaceConfig', sortFeatures?: boolean | null, hideArticleCounter?: boolean | null } | null } | null };

export type OrderQueryVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type OrderQuery = { __typename?: 'Query', orderById?: { __typename?: 'PublicOrder', _id: string, code?: string | null, paymentStatus?: string | null, quantities?: Array<{ __typename?: 'Quantity', quantity: number, price: number, article: { __typename?: 'Article', _id: string, name: string } | { __typename?: 'DonationArticle', _id: string, name: string } | { __typename?: 'ShippingCostsArticle', _id: string, name: string } } | null> | null, sellerGroup?: { __typename?: 'PublicSellerGroup', _id: string, code: string } | null } | null };

export type ScoreboardQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ScoreboardQuery = { __typename?: 'Query', scoreboard?: Array<{ __typename?: 'PublicSellerGroup', _id: string, names: string, link: string, points: number, position: number, tags: Array<string | null> } | null> | null };

export type SellerGroupsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type SellerGroupsQuery = { __typename?: 'Query', campaignBySlug?: { __typename?: 'Campaign', slug: string, sellerGroups?: Array<{ __typename?: 'PublicSellerGroup', _id: string, code: string, names: string }> | null } | null };

export type SellerGroupQueryVariables = Exact<{
  slug: Scalars['String'];
  secret: Scalars['String'];
}>;


export type SellerGroupQuery = { __typename?: 'Query', sellerGroup: { __typename?: 'PublicSellerGroup', _id: string, code: string, points: number, position: number, offset: number, orders: Array<{ __typename?: 'SecretPublicOrder', _id: string, name: string, code?: string | null, email?: string | null, deliveryMethod?: DeliveryMethod | null, amountPaid?: number | null, datePaid?: any | null, cardsCount?: number | null, collectTimeslot?: { __typename?: 'Timeslot', start: any, end: any } | null, address?: { __typename?: 'Address', description: string } | null, customFields?: Array<{ __typename?: 'CustomField', _id?: string | null, value?: Array<string | null> | null, formField?: { __typename?: 'FormField', _id: string, label: string } | null }> | null, quantities: Array<{ __typename?: 'Quantity', quantity: number, price: number, article: { __typename?: 'Article', description?: string | null, _id: string, price: number, name: string } | { __typename?: 'DonationArticle', _id: string, price: number, name: string } | { __typename?: 'ShippingCostsArticle', _id: string, price: number, name: string } }> }>, sellers?: Array<{ __typename?: 'Seller', _id: string, firstName: string, lastName?: string | null }> | null } };


export const DeleteSellerGroupDocument = gql`
    mutation DeleteSellerGroup($_id: ID!) {
  deleteSellergroup(_id: $_id) {
    removalDate
  }
}
    `;
export type DeleteSellerGroupMutationFn = Apollo.MutationFunction<DeleteSellerGroupMutation, DeleteSellerGroupMutationVariables>;

/**
 * __useDeleteSellerGroupMutation__
 *
 * To run a mutation, you first call `useDeleteSellerGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSellerGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSellerGroupMutation, { data, loading, error }] = useDeleteSellerGroupMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteSellerGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSellerGroupMutation, DeleteSellerGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSellerGroupMutation, DeleteSellerGroupMutationVariables>(DeleteSellerGroupDocument, options);
      }
export type DeleteSellerGroupMutationHookResult = ReturnType<typeof useDeleteSellerGroupMutation>;
export type DeleteSellerGroupMutationResult = Apollo.MutationResult<DeleteSellerGroupMutation>;
export type DeleteSellerGroupMutationOptions = Apollo.BaseMutationOptions<DeleteSellerGroupMutation, DeleteSellerGroupMutationVariables>;
export const OrderMutationDocument = gql`
    mutation OrderMutation($slug: String!, $order: InsertOrderInput, $orderId: String) {
  createStripeSession(slug: $slug, order: $order, orderId: $orderId) {
    stripeSessionId
  }
}
    `;
export type OrderMutationMutationFn = Apollo.MutationFunction<OrderMutationMutation, OrderMutationMutationVariables>;

/**
 * __useOrderMutationMutation__
 *
 * To run a mutation, you first call `useOrderMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderMutationMutation, { data, loading, error }] = useOrderMutationMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      order: // value for 'order'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderMutationMutation(baseOptions?: Apollo.MutationHookOptions<OrderMutationMutation, OrderMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderMutationMutation, OrderMutationMutationVariables>(OrderMutationDocument, options);
      }
export type OrderMutationMutationHookResult = ReturnType<typeof useOrderMutationMutation>;
export type OrderMutationMutationResult = Apollo.MutationResult<OrderMutationMutation>;
export type OrderMutationMutationOptions = Apollo.BaseMutationOptions<OrderMutationMutation, OrderMutationMutationVariables>;
export const ArticlePackageDocument = gql`
    query ArticlePackage($_id: ID!) {
  articlePackage(_id: $_id) {
    _id
    slug
    name
    locales
    articleTemplates(first: 150) {
      _id
      imageUrls
      name
      sellingPrice
      description
      extraInfo {
        title
        description
      }
      groupId
      features {
        key
        value
      }
    }
    defaultCampaignSettings {
      headerImgUrl
      color
      deliveryOptions {
        deliveryMethods
      }
      minimumTotalArticleCount
      minimumOrderValue
    }
    partner {
      locale
    }
  }
}
    `;

/**
 * __useArticlePackageQuery__
 *
 * To run a query within a React component, call `useArticlePackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlePackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticlePackageQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useArticlePackageQuery(baseOptions: Apollo.QueryHookOptions<ArticlePackageQuery, ArticlePackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticlePackageQuery, ArticlePackageQueryVariables>(ArticlePackageDocument, options);
      }
export function useArticlePackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticlePackageQuery, ArticlePackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticlePackageQuery, ArticlePackageQueryVariables>(ArticlePackageDocument, options);
        }
export type ArticlePackageQueryHookResult = ReturnType<typeof useArticlePackageQuery>;
export type ArticlePackageLazyQueryHookResult = ReturnType<typeof useArticlePackageLazyQuery>;
export type ArticlePackageQueryResult = Apollo.QueryResult<ArticlePackageQuery, ArticlePackageQueryVariables>;
export const CampaignDocument = gql`
    query Campaign($slug: String!) {
  campaignBySlug(slug: $slug) {
    slug
    name
    headerImgUrl
    textConfig {
      deliveryLabel
      emailLabel
      emailDescription
      nameLabel
      nameDescription
      sellerGroupLabel
      sellerGroupDescription
      sellerGroupPlaceholder
      addressLabel
      scoreboard
      info
      sellerGroupLabel
      sellingDisabled
      variantUnavailable
      delivery
    }
    openGraphTags {
      title
      description
      imageUrl
    }
    articles {
      _id
      name
      price
      ... on Article {
        imageUrls
        description
        itemsLeft
        groupId
        features {
          key
          value
          type
          label
        }
        heading
      }
    }
    deliveryOptions {
      deliveryMethods
      deliveryCountries
      deliveryRadii {
        centralAddress {
          description
          coordinates
        }
        radius
      }
      minimumTotalPrice
    }
    organisation {
      locale
    }
    formFields {
      _id
      label
      description
      placeholder
      isRequired
      isMultiselect
      isDisabled
      options
      type
    }
    timeslots {
      collect {
        start
        end
        badge
        isDisabled
      }
      deliver {
        start
        end
        badge
        isDisabled
      }
      eatIn {
        start
        end
        badge
        isDisabled
      }
    }
    isSellingEnabled
    minimumTotalArticleCount
    minimumOrderValue
    isSellerGroupRequired
    showScoreboard
    winnerCount
    acceptDonations
    interfaceConfig {
      sortFeatures
      hideArticleCounter
    }
    onlyFinalOrderAllowed
  }
}
    `;

/**
 * __useCampaignQuery__
 *
 * To run a query within a React component, call `useCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCampaignQuery(baseOptions: Apollo.QueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
      }
export function useCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
        }
export type CampaignQueryHookResult = ReturnType<typeof useCampaignQuery>;
export type CampaignLazyQueryHookResult = ReturnType<typeof useCampaignLazyQuery>;
export type CampaignQueryResult = Apollo.QueryResult<CampaignQuery, CampaignQueryVariables>;
export const OrderDocument = gql`
    query Order($_id: ID!) {
  orderById(_id: $_id) {
    _id
    code
    quantities {
      article {
        _id
        name
      }
      quantity
      price
    }
    paymentStatus
    sellerGroup {
      _id
      code
    }
  }
}
    `;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export const ScoreboardDocument = gql`
    query Scoreboard($slug: String!) {
  scoreboard(slug: $slug) {
    _id
    names
    link
    points
    position
    tags
  }
}
    `;

/**
 * __useScoreboardQuery__
 *
 * To run a query within a React component, call `useScoreboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useScoreboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScoreboardQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useScoreboardQuery(baseOptions: Apollo.QueryHookOptions<ScoreboardQuery, ScoreboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScoreboardQuery, ScoreboardQueryVariables>(ScoreboardDocument, options);
      }
export function useScoreboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScoreboardQuery, ScoreboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScoreboardQuery, ScoreboardQueryVariables>(ScoreboardDocument, options);
        }
export type ScoreboardQueryHookResult = ReturnType<typeof useScoreboardQuery>;
export type ScoreboardLazyQueryHookResult = ReturnType<typeof useScoreboardLazyQuery>;
export type ScoreboardQueryResult = Apollo.QueryResult<ScoreboardQuery, ScoreboardQueryVariables>;
export const SellerGroupsDocument = gql`
    query SellerGroups($slug: String!) {
  campaignBySlug(slug: $slug) {
    slug
    sellerGroups {
      _id
      code
      names
    }
  }
}
    `;

/**
 * __useSellerGroupsQuery__
 *
 * To run a query within a React component, call `useSellerGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerGroupsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSellerGroupsQuery(baseOptions: Apollo.QueryHookOptions<SellerGroupsQuery, SellerGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerGroupsQuery, SellerGroupsQueryVariables>(SellerGroupsDocument, options);
      }
export function useSellerGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerGroupsQuery, SellerGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerGroupsQuery, SellerGroupsQueryVariables>(SellerGroupsDocument, options);
        }
export type SellerGroupsQueryHookResult = ReturnType<typeof useSellerGroupsQuery>;
export type SellerGroupsLazyQueryHookResult = ReturnType<typeof useSellerGroupsLazyQuery>;
export type SellerGroupsQueryResult = Apollo.QueryResult<SellerGroupsQuery, SellerGroupsQueryVariables>;
export const SellerGroupDocument = gql`
    query SellerGroup($slug: String!, $secret: String!) {
  sellerGroup(slug: $slug, secret: $secret) {
    _id
    code
    points
    position
    offset
    orders {
      _id
      name
      code
      email
      deliveryMethod
      collectTimeslot {
        start
        end
      }
      address {
        description
      }
      amountPaid
      customFields {
        _id
        value
        formField {
          _id
          label
        }
      }
      quantities {
        quantity
        price
        article {
          _id
          price
          name
          ... on Article {
            description
          }
        }
      }
      datePaid
      cardsCount
    }
    sellers {
      _id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useSellerGroupQuery__
 *
 * To run a query within a React component, call `useSellerGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerGroupQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      secret: // value for 'secret'
 *   },
 * });
 */
export function useSellerGroupQuery(baseOptions: Apollo.QueryHookOptions<SellerGroupQuery, SellerGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerGroupQuery, SellerGroupQueryVariables>(SellerGroupDocument, options);
      }
export function useSellerGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerGroupQuery, SellerGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerGroupQuery, SellerGroupQueryVariables>(SellerGroupDocument, options);
        }
export type SellerGroupQueryHookResult = ReturnType<typeof useSellerGroupQuery>;
export type SellerGroupLazyQueryHookResult = ReturnType<typeof useSellerGroupLazyQuery>;
export type SellerGroupQueryResult = Apollo.QueryResult<SellerGroupQuery, SellerGroupQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "IArticle": [
      "Article",
      "DonationArticle",
      "ShippingCostsArticle"
    ],
    "IPageInfo": [
      "CampaignPageInfo",
      "PageInfo"
    ],
    "Tenant": [
      "Organisation",
      "Partner"
    ]
  }
};
      export default result;
